import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationUserDoubleOptInPatch = {
    path: "/user/double-opt-in",
    method: ERouteHttpVerb.PATCH
};
export { routeLocationUserDoubleOptInPatch };
